import { FC } from 'react';

import { toast } from 'sonner';
import { BaseModal } from 'wbs-components-lib';

import { useDoneVipTaskItemMutation } from '@services';

import {
  VIP_TASK_ITEM_FORM_INITIAL_VALUES,
  VipUserTaskForm,
  VipUserTaskFormValues,
} from '../../VipSettingsForms/VipUserTaskForm';

import { VipUserTasksConfigurationModalProps } from './types';

export const VipUserTasksConfigurationModal: FC<VipUserTasksConfigurationModalProps> = ({
  isOpened,
  handleClose,
  userId,
  userNickname,
  refetch,
}) => {
  const [doneVipTaskItem, { isLoading: isVipTaskItemUpdating }] = useDoneVipTaskItemMutation();

  const handleCloseWithClear = () => {
    handleClose();
  };

  const updateTaskItemStatus = async (values: VipUserTaskFormValues) => {
    const { vipTaskItem } = values;

    await doneVipTaskItem({ vipTaskItemId: vipTaskItem, userId }).unwrap();

    await refetch();

    toast.success('Success: VIP task item status has been updated!');

    handleClose();
  };

  const headerTitle = `Configure VIP tasks for ${userNickname}`;

  return (
    <>
      <BaseModal
        headerTitle={headerTitle}
        handleClose={handleCloseWithClear}
        isOpened={isOpened}
        buttonConfirmedText="Update"
        isFooterNeeded={false}
      >
        <VipUserTaskForm
          initialValues={VIP_TASK_ITEM_FORM_INITIAL_VALUES}
          userId={userId}
          onSubmit={updateTaskItemStatus}
          isSubmitting={isVipTaskItemUpdating}
        />
      </BaseModal>
    </>
  );
};
